<script setup lang="ts">
import type { DetectionFilters } from '@/types/filters/DetectionFilters'
import type { DetectionModel } from '@/types/models/DetectionModel'
import DetectionsFilters from '../DetectionsFilters.vue'

type Props = {
    filters: DetectionFilters
}
defineProps<Props>()

type Emits = {
    (e: 'change', value: Partial<DetectionModel>): void
}
defineEmits<Emits>()
</script>

<template>
    <DetectionsFilters :filters="filters" @change="$emit('change', $event)" />
</template>
